import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useCallback, useMemo, useState } from 'react';
import { useId } from '@reach/auto-id';
import { TabsContext } from "./TabsContext";
import { useControlledComponent } from "../../hooks";
export function Tabs(_ref) {
  var name = _ref.name,
      children = _ref.children,
      onChange = _ref.onChange,
      valueProp = _ref.value,
      defaultValue = _ref.defaultValue,
      mountedTabsProp = _ref.mountedTabs,
      defaultMountedTabs = _ref.defaultMountedTabs,
      onChangeMountedTabs = _ref.onChangeMountedTabs;
  var id = useId(name);

  var _useControlledCompone = useControlledComponent(valueProp, onChange, defaultValue),
      _useControlledCompone2 = _slicedToArray(_useControlledCompone, 2),
      value = _useControlledCompone2[0],
      setValue = _useControlledCompone2[1];

  var _useState = useState(function () {
    return new Set([value]);
  }),
      _useState2 = _slicedToArray(_useState, 1),
      defaultSet = _useState2[0];

  var _useControlledCompone3 = useControlledComponent(mountedTabsProp, onChangeMountedTabs, defaultMountedTabs !== null && defaultMountedTabs !== void 0 ? defaultMountedTabs : defaultSet),
      _useControlledCompone4 = _slicedToArray(_useControlledCompone3, 2),
      mountedTabs = _useControlledCompone4[0],
      setMountedTabs = _useControlledCompone4[1];

  var onMountTabs = useCallback(function (mount) {
    setMountedTabs(mount);
  }, [setMountedTabs]);
  var tabsContext = useMemo(function () {
    return {
      id: id,
      onChange: setValue,
      value: value,
      mountedTabs: mountedTabs,
      onMountTabs: onMountTabs
    };
  }, [id, mountedTabs, onMountTabs, setValue, value]);
  return /*#__PURE__*/React.createElement(TabsContext.Provider, {
    value: tabsContext
  }, children);
}